import { useState } from "react";
import axios from "axios";
import { MessageCircle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const WHATSAPP_NUMBER = "5532999103556";

export const LeadModal = ({ open, onOpenChange, plan }) => {
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    setSubmitting(true);

    try {
      await axios.post(`${API}/leads`, { name: trimmed, plan });
    } catch (err) {
      console.error("Erro ao salvar lead:", err);
    }

    const planText =
      plan && plan !== "geral" && plan !== "whatsapp" && plan !== "header" && plan !== "hero"
        ? ` Tenho interesse no plano ${plan}.`
        : "";
    const message = encodeURIComponent(
      `Olá, me chamo ${trimmed} e quero conhecer o New Braz!${planText}`
    );
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, "_blank");

    setSubmitting(false);
    setName("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="lead-modal"
        className="bg-[#0F0F13] border border-white/15 text-white sm:max-w-md rounded-2xl"
      >
        <DialogHeader>
          <DialogTitle className="text-2xl font-black tracking-tighter" style={{ fontFamily: "Outfit, sans-serif" }}>
            Quase lá! <span className="text-[#FF5A00]">Qual seu nome?</span>
          </DialogTitle>
          <DialogDescription className="text-white/55">
            Informe seu nome e fale agora com nossa equipe no WhatsApp. Atendimento imediato!
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-2">
          <input
            data-testid="input-lead-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Digite seu nome"
            autoFocus
            required
            className="w-full bg-black/40 border border-white/15 rounded-lg px-4 py-3.5 text-white placeholder:text-white/35 focus:outline-none focus:border-[#FF5A00] transition-colors"
          />
          <button
            data-testid="submit-lead"
            type="submit"
            disabled={submitting || !name.trim()}
            className="w-full bg-[#25D366] hover:bg-[#1EBE5D] disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold rounded-lg py-4 transition-colors flex items-center justify-center gap-2 text-lg"
          >
            <MessageCircle className="w-5 h-5" />
            {submitting ? "Aguarde..." : "Ir para o WhatsApp"}
          </button>
        </form>
        <p className="text-xs text-white/35 text-center">
          Você será redirecionado para o WhatsApp oficial da New Braz.
        </p>
      </DialogContent>
    </Dialog>
  );
};
